import React from 'react';
import { AddOn } from './AddOn';

export class Salesforce extends AddOn {
  public get shortDescription(): string {
    return 'Create and update leads or contacts in Salesforce with interaction responses, behavioral data, and more for all your webinar registrants.';
  }

  public get description(): string {
    return 'Create and update leads or contacts in Salesforce with interaction responses, behavioral data, and more for all your webinar registrants.';
  }

  public get disclosure(): React.ReactElement | null {
    return (
      <p>
        <b>NOTE</b>: When you use eWebinar’s integration with Salesforce, your registration
        information will be disclosed to SFDC pursuant to its privacy policy available at{' '}
        <a target='_blank' href='https://salesforce.com'>
          salesforce.com
        </a>
        .
      </p>
    );
  }

  public image(): string | null {
    return require('$/images/logos/big-salesforce.png').default;
  }
}
